// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <detail-view
  :endpoint="endpoint + 'owners'"
  name="Owner"
  parentRoute="owners"
  permissions="owners"
  :values="values"
  ></detail-view>
</template>
<script>
import {ENDPOINT} from '@/shared/constants'
import DetailView from 'vue-common/components/DetailView.vue'

export default {
  components: {
    DetailView
  },

  data () {
    return {
      endpoint: ENDPOINT,
      values: [
        {
          name: 'Basic',
          items: [
            [
              {
                name: 'Name',
                value: 'name',
                required: true
              },
              {
                name: 'Subdomain',
                value: 'subdomain',
                required: true
              }
            ]
          ]
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/OwnerEdit.vue